/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBakeryDiningIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-bakery-dining"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M20.18 18.57L18.07 17.75L20.18 12.7L21.93 16.73Q22.32 17.6 21.73 18.27Q21.13 18.95 20.18 18.57ZM14.38 17.55L15.57 7.83Q15.65 7.25 16.06 7.08Q16.48 6.9 17.05 7.13L18.85 7.85Q19.35 8.05 19.56 8.53Q19.77 9 19.57 9.57L16.57 17.55ZM6.6 17.55L3.6 9.57Q3.4 9.03 3.59 8.55Q3.77 8.07 4.33 7.85L6.13 7.13Q6.67 6.9 7.1 7.08Q7.53 7.25 7.6 7.83L8.8 17.55ZM3 18.57Q2.05 18.95 1.45 18.27Q0.85 17.6 1.25 16.73L3 12.7L5.1 17.75ZM10.32 17.55L9.13 6.2Q9.05 5.55 9.51 5.13Q9.97 4.7 10.63 4.7L12.55 4.7Q13.2 4.7 13.66 5.13Q14.13 5.55 14.05 6.2L12.85 17.55Z" fill={color} />
    </svg>
  );
}
